<template>
  <div
    class="navItemWrapper"
    :class="{ valid: isValid }"
  >
    <el-menu-item
      :disabled="disabled"
      :class="{ active: selected, valid: isValid && !disabled, invalid: !isValid && !disabled }"
      class="navItem"
      index="records-justif"
    >
      <span class="item">
        <md-icon name="attach_file" />
        <span>{{ $t('records.nav.justifs') }}</span>
      </span>
    </el-menu-item>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import NavRecordsInterface from './NavRecordsInterface'

export default {
  name: "NavRecordsJustif",
  extends: NavRecordsInterface,
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      currentRecordTenants: state => state.recordsPeople.currentRecordTenants,
      currentRecordGuarantors: state => state.recordsPeople.currentRecordGuarantors,
      currentRecordTenantsDocuments: state => state.recordsDocuments.currentRecordTenantsDocuments,
      currentRecordGuarantorsDocuments: state => state.recordsDocuments.currentRecordGuarantorsDocuments
    }),
    people() {
      let guarantorsCount = 1
      let tenantsCount = 1

      return [
        ...this.currentRecordTenants.map(item => {
          item.order = tenantsCount
          tenantsCount++

          return item
        }),
        ...this.currentRecordGuarantors.map(item => {
          item.order = guarantorsCount
          guarantorsCount++

          return item
        })
      ]
    },
    personDocuments() {
      return id => {
        const guarantors = this.currentRecordGuarantors.length > 0 ? this.currentRecordGuarantorsDocuments : {}
        const documents = {
          ...this.currentRecordTenantsDocuments,
          ...guarantors
        }
        return documents && documents[id] ? documents[id].filter(document => document.required && !document.document).length : 0
      }
    },
    isValid() {
      return this.people.length > 0 && this.people.reduce((p, n) => p + this.personDocuments(n.id), 0) === 0
    }
  }
}
</script>
